import React, { Component } from 'react';

class LinkListChicago extends Component {

    render(){

        let containerFont = this.props.fontClass ? null : "Ostrich";
        let containerSelectedFont = this.props.fontClass ? null : "Ostrich";
        let fontClass = this.props.fontClass;

        let containerStyle={
            borderRadius: 25,
            fontFamily: containerFont,
            width: this.props.screen.sv.p10*6,
            minHeight: this.props.screen.sv.p10*1,
            color: this.props.colorInactive,
            marginLeft: this.props.screen.sv.p10*0.4,
            letterSpacing: 1
        }

        let containerStyleSelected={
            borderRadius: 25,
            fontFamily: containerSelectedFont,
            backgroundColor: '#496778',
            width: this.props.screen.sv.p10*6,
            minHeight: this.props.screen.sv.p10*1,
            color: 'white',
            marginLeft: this.props.screen.sv.p10*0.4,
            letterSpacing: 1
        }

        let innerStyle={
            fontSize: this.props.screen.sv.p10*0.3,
            width: this.props.screen.sv.p10*2,
            marginLeft: this.props.screen.sv.p10*0.3,
            marginTop: this.props.screen.r16_9.p10*0.5,
            marginBottom: this.props.screen.r16_9.p10*0.5
        }

        return(
            <div className={fontClass} style={{Display: 'flex', alignItems: "center"}}>
            {this.props.links.map(function (row, i) {
                return (

                    <div className="valigner" onClick={() => this.props.switchCategory(i)} key={i} style={this.props.selectedLinkIndex===i? containerStyleSelected : containerStyle}>

                        <div className="valigner-item">
                    <div style={innerStyle}>{row.name}</div>
                    </div>

                    </div>

                )
            }, this)}
            </div>
        )
    }
}

export default LinkListChicago


// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/LinkListChicago.js